import DirectLinksComponent from "./DirectLinksComponent";

export default DirectLinksComponent;